import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Box } from "@mui/material";

import useEntity from "../../hooks/useEntity";
import useLocalization from "../../hooks/useLocalization";
import useData from "../../hooks/useData";

import Page from "./Page";
import Card from "../layout/Card";
import TerritoryEditor from "../editors/TerritoryEditor";
import TerritoryLocations from "../ui/TerritoryLocations";

const Territory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { getTitle } = useLocalization();
  const { getFromServer, updateRecord } = useData();

  const [territoryId, setTerritoryId] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const [syndicationId, setSyndicationId] = useState(null);
  const [territory, setTerritory] = useState(null);
  const [deleteTerritory, setDeleteTerritory] = useState(false);

  const {
    setEntityName,
    getEntityData,
    entityData,
    updateField,
    message,
    saved,
  } = useEntity();

  useEffect(() => {
    setTerritoryId(location.state.territoryId);
    if (location.state.projectId) {
      setProjectId(location.state.projectId);
      setEntityName("Project");
    } else {
      setSyndicationId(location.state.syndicationId);
      setEntityName("Syndication");
    }
  }, []);

  useEffect(() => {
    getData();
  }, [projectId, syndicationId, territoryId]);

  const getData = async () => {
    if ((!projectId && !syndicationId) || !territoryId) return;

    if (projectId) {
      getEntityData(projectId);
    } else {
      getEntityData(syndicationId);
    }

    const territoryData = await getFromServer({
      entityName: "Territory",
      id: territoryId,
    });
    if (territoryData) {
      setTerritory(territoryData);
    } else {
      setTerritory(null);
    }
  };

  useEffect(() => {
    if (!saved || !deleteTerritory) return;

    if (projectId) {
      navigate("/project", {
        state: { projectId, clientId: entityData.clientId },
      });
    } else {
      navigate("/syndication");
    }
  }, [saved, deleteTerritory]);

  const handleToolbarClick = (name) => {
    switch (name) {
      case "project":
        navigate("/project", {
          state: { projectId, clientId: entityData.clientId },
        });
        break;

      case "syndication":
        navigate("/syndication");
        break;
    }
  };

  const handleSave = async () => {
    await getData();
  };

  const handleDelete = async (data) => {
    setDeleteTerritory(true);
  };

  const toolbarItems = () => {
    if (projectId) {
      return [{ name: "project", iconName: "ListAlt" }];
    } else {
      return [{ name: "syndication", iconName: "ListAlt" }];
    }
  };

  if (!territory || !entityData) return null;

  return (
    <Page
      pageName={entityData?.name ? entityData.name : "Territory"}
      entityName={territory.name}
      includeToolbar
      items={toolbarItems()}
      onToolItemClick={handleToolbarClick}
    >
      <Box
        display="flex"
        gap={1}
      >
        <Card
          title={getTitle("territoryInformation")}
          width="300px"
        >
          <TerritoryEditor
            territoryId={territoryId}
            onSave={handleSave}
            onDelete={handleDelete}
            users={[]}
            message={message}
          />
        </Card>

        <Card
          title={getTitle("locations")}
          width="100%"
        >
          <TerritoryLocations
            syndicationId={syndicationId}
            projectId={projectId}
            territoryId={territoryId}
          />
        </Card>
      </Box>
    </Page>
  );
};

export default Territory;
